import { render, staticRenderFns } from "./AuthMultiLanguage.vue?vue&type=template&id=2fd957ca&"
import script from "./AuthMultiLanguage.vue?vue&type=script&lang=ts&"
export * from "./AuthMultiLanguage.vue?vue&type=script&lang=ts&"
import style0 from "./AuthMultiLanguage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VOverflowBtn } from 'vuetify/lib/components/VOverflowBtn';
installComponents(component, {VListItem,VListItemTitle,VOverflowBtn})
